import { useQuery } from '@tanstack/react-query'
import { deviceRowQuery } from '../api/opteemum'
import { Content } from '../ui/Shell'
import { DataTable, useTableState } from '../ui/DataTable'
import { DeviceWorkspace } from '../devices/DeviceWorkspace'
import { pageDeviceColumns, type DeviceRow } from './columns'

/**
 * /opteemum/device/{id} — opteemum/device/index.php + details.php (#opteemumDevice).
 * Fara id sau in afara firmei: "Device is undefined".
 */

export function DevicePage({ id }: { id: number }) {
  const valid = Number.isFinite(id) && id > 0
  const query = useQuery({ ...deviceRowQuery(id), enabled: valid })
  const [state, setState] = useTableState('opteemumDevice', { start: 0, length: 10, order: { column: 1, dir: 'asc' }, search: '' })
  const columns = pageDeviceColumns()
  const missing = !valid || query.isError || !query.data
  const row = (query.data ?? {}) as DeviceRow

  return (
    <Content>
      {missing ? (
        <div className="notifications">
          <div className="alert alert-danger">
            <i className="fas fa-info-circle"></i> Device is undefined
          </div>
        </div>
      ) : (
        <div id="content">
          <div className="deviceTable">
            <DataTable
              id="opteemumDevice"
              columnTools
              columns={columns}
              rows={[row]}
              total={1}
              fetching={query.isFetching}
              error={null}
              state={state}
              onState={setState}
              rowId={(r) => String(r.DT_RowId ?? `row_${r.deviceId}`)}
              details={() => <DeviceWorkspace id={id} from="opteemum" />}
            />
          </div>
        </div>
      )}
    </Content>
  )
}
